import * as Yup from 'yup';
import createTurnoFormModel from './createTurnoFormModel';

const {
  formField: {
    cargo,
    start_hour,
    end_hour,
    dia,
    tarde,
    noche,
    tarifa,
    anio
  }

} = createTurnoFormModel;


export default [

  Yup.object().shape({ 
       
    
    
    [cargo.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${cargo.requiredErrorMsg}`),
    [start_hour.name]: Yup.string().required(`${start_hour.requiredErrorMsg}`),
    [end_hour.name]: Yup.string().required(`${end_hour.requiredErrorMsg}`),
    [tarifa.name]: Yup.number().required(`${tarifa.requiredErrorMsg}`),
    [anio.name]: Yup.number().required(`${anio.requiredErrorMsg}`),

  })
  
];  

    